import { Session } from '@chilipiper/api-type-def'
import { ProductStatus } from '@chilipiper/api-type-def/lib/license'
import { store } from './store'
import { setUser } from './sentry'

declare const window: any
let session: Session = {
  user: {},
  licences: {
    events: {
      status: ProductStatus.Inactive,
    },
    mildMeetings: {
      status: ProductStatus.Inactive,
    },
    meetings: {
      status: ProductStatus.Inactive,
    },
    concierge: {
      status: ProductStatus.Inactive,
    },
  },
  workspaces: {
    adminOf: [],
  },
  products: [],
}

export const create = (data: Session) => {
  session = data
  setUser({ email: session.email })
}

export const update = (data: Session) => {
  session = data
  setUser({ email: session.email })
}

export const getSession = () => session

export const email = () => session.email

export const token = () => session.token

export const fullName = () =>
  session.user.displayName || `${session.user.platformFirstName} ${session.user.platformLastName}`

export const admin = () => {
  return (
    session.admin ||
    session.workspaceAdmin ||
    !!(session.workspaces && session.workspaces.adminOf?.length)
  )
}

export const isWorkspaceAdmin = () => {
  return session.workspaceAdmin || !!(session.workspaces && session.workspaces.adminOf?.length)
}

export const superAdmin = () => session.admin

export const adminOfWorkspace = (id: string) =>
  session.admin || (session.workspaces.adminOf || []).includes(id)

export const isInboxOnlyUser = () => {
  return session.admin && session.products.length === 1 && session.products[0] === 'Inbox'
}

export const setSessionId = (id: string) => {
  store.set('sessionId', id)
  window.sessionId = id
}

export const getSessionId = () => window.sessionId || store.session.get('sessionId')

export const getUser = () => session.user

export const hasSalesforce = () => session.crm?.type === 'Salesforce'

export const hasHubspot = () => session.crm?.type === 'Hubspot' && !!session.crm?.id

export const getCrmType = () => session.crm?.type

export const isHotLicense = () => session.licences?.meetings.status === ProductStatus.Active

export default {
  getSession,
}
